import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import Sites from './pages/Sites';
import Cameras from './pages/Cameras';
import Alarms from './pages/Alarms';
import AccessControl from './pages/AccessControl';
import Reports from './pages/Reports';
import SecurityReports from './pages/SecurityReports';
import Planning from './pages/Planning';
import SalaryCalculator from './pages/SalaryCalculator';
import PlanningAdvanced from './pages/PlanningAdvanced';
import PlanningPro from './pages/PlanningPro';
import AIInsights from './pages/AIInsights';
import Settings from './pages/Settings';
import Register from './pages/Register';
import RegisterCompany from './pages/RegisterCompany';
import RegisterAdmin from './pages/RegisterAdmin';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import CybersecDashboard from './pages/CybersecDashboard';
import VerifyRonde from './pages/VerifyRonde';
import Layout from './components/Layout';
import { AuthProvider } from './contexts/AuthContext';
// Documents & Formalités
import DeclarationsFormalites from './pages/DeclarationsFormalites';
import DocumentsGenerator from './pages/DocumentsGenerator';
// SSI - Sécurité Incendie
import SSIDashboard from './pages/SSIDashboard';
import EquipementsIncendie from './pages/EquipementsIncendie';
import MaintenancesSSI from './pages/MaintenancesSSI';
import RegistreSSI from './pages/RegistreSSI';
import PlanningSSI from './pages/PlanningSSI';
// Main Courante
import MainCourante from './pages/MainCourante';
import RegistreControles from './pages/RegistreControles';
import RegistrePersonnel from './pages/RegistrePersonnel';
import VariablesPaie from './pages/VariablesPaie';
import CentrePaieIA from './pages/CentrePaieIA';
import UsersManagement from './pages/UsersManagement';
import SecurIA from './pages/SecurIA';
import TribunalIA from './pages/TribunalIA';
import AlfaIA from './pages/AlfaIA';
import AlfaFederated from './pages/AlfaFederated';
// Abonnements
import Abonnements from './pages/Abonnements';
// Rondes et Sous-traitants
import Rondes from './pages/Rondes';
import Subcontractors from './pages/Subcontractors';
// Logistique
import Logistique from './pages/Logistique';
import AgentMobilePortal from './pages/AgentMobilePortal';
import SaaSPricing from './pages/SaaSPricing';
import Agents from './pages/Agents';
import DashboardRH from './pages/DashboardRH';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-ronde" element={<VerifyRonde />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-company" element={<RegisterCompany />} />
            <Route path="/register-admin" element={<RegisterAdmin />} />
            <Route path="/dashboard" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="agent-portal" element={<AgentMobilePortal />} />
              <Route path="sites" element={<Sites />} />
              <Route path="agents" element={<Agents />} />
              <Route path="cameras" element={<Cameras />} />
              <Route path="alarms" element={<Alarms />} />
              <Route path="access" element={<AccessControl />} />
              <Route path="reports" element={<Reports />} />
              <Route path="security-reports" element={<SecurityReports />} />
              <Route path="planning" element={<Planning />} />
              <Route path="planning-advanced" element={<PlanningAdvanced />} />
              <Route path="planning-pro" element={<PlanningPro />} />
              <Route path="salary-calculator" element={<SalaryCalculator />} />
              <Route path="ai-insights" element={<AIInsights />} />
              <Route path="cybersec" element={<CybersecDashboard />} />
              <Route path="declarations" element={<DeclarationsFormalites />} />
              <Route path="documents" element={<DocumentsGenerator />} />
              <Route path="ssi" element={<SSIDashboard />} />
              <Route path="ssi/equipements" element={<EquipementsIncendie />} />
              <Route path="ssi/maintenances" element={<MaintenancesSSI />} />
              <Route path="ssi/registre" element={<RegistreSSI />} />
              <Route path="ssi/planning" element={<PlanningSSI />} />
              <Route path="main-courante" element={<MainCourante />} />
              <Route path="registre-controles" element={<RegistreControles />} />
              <Route path="registre-personnel" element={<RegistrePersonnel />} />
              <Route path="variables-paie" element={<VariablesPaie />} />
              <Route path="centre-paie-ia" element={<CentrePaieIA />} />
              <Route path="dashboard-rh" element={<DashboardRH />} />
              <Route path="abonnements" element={<Abonnements />} />
              <Route path="pricing" element={<SaaSPricing />} />
              <Route path="rondes" element={<Rondes />} />
              <Route path="subcontractors" element={<Subcontractors />} />
              <Route path="logistique" element={<Logistique />} />
              <Route path="settings" element={<Settings />} />
              <Route path="users" element={<UsersManagement />} />
              <Route path="securia" element={<SecurIA />} />
              <Route path="tribunal-ia" element={<TribunalIA />} />
              <Route path="alfa" element={<AlfaIA />} />
              <Route path="alfa-federated" element={<AlfaFederated />} />
            </Route>
          </Routes>
          <Toaster />
          <InstallPrompt />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;